import { useEffect } from "react";
import ScrollReveal from "scrollreveal";

export const useScrollReveal = (configs = []) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      configs.forEach(({ selector, options }) => {
        ScrollReveal().reveal(selector, options);
      });
    }
  }, [configs]);
};
